import React from 'react';
import { isPresentInArray } from '../../../../../itrust_common/components/HelperFunctions';
import DisplayField from '../../../../../itrust_common/components/others/DisplayField'

let Impression = props => {
  const { fieldsValues, selectedIds, handleIdsSelect, overviewName } = props;
  return (
    <div className="row">
      <div className="col-12 py-4">
        <div className="overview-table mb-3">
          <table className="table bg-light table-hover shadow-none border border-muted">
            <thead className="text-dark border border-muted">
              <tr className="text-center">
                <th scope="col">
                  <DisplayField
                    isVisible={true}
                    label={"No."}
                  />
                </th>
                <th scope="col">
                  <DisplayField
                    isVisible={true}
                    label={"Impression"}
                  />
                </th>
                <th scope="col">
                  <DisplayField
                    isVisible={true}
                    label={"Code"}
                  />
                </th>
                <th scope="col">
                  <DisplayField
                    isVisible={true}
                    label={"Plan"}
                  />
                </th>
                {overviewName && <th scope="col">
                  <DisplayField
                    isVisible={true}
                    label={"Select"}
                  />
                </th>}
              </tr>
            </thead>
            <tbody>
              {fieldsValues.map((impression, index) =>
                <tr className="text-center">
                  <td>
                    <DisplayField
                      isVisible={true}
                      value={String.fromCharCode(index + 97).toUpperCase()}
                    />
                  </td>
                  <td>
                    <DisplayField
                      isVisible={true}
                      value={impression.impression && impression.impression.name}
                    />
                  </td>
                  <td>
                    <DisplayField
                      isVisible={true}
                      value={impression.impression && impression.impression.code}
                    />
                  </td>
                  <td>
                    <DisplayField
                      isVisible={true}
                      value={impression.associated_plans_attributes?.map(plan => plan.name).join(', ')}
                    />
                  </td>
                  {overviewName && <td>
                    <div className="custom-control custom-checkbox">
                      <input
                        onChange={() => handleIdsSelect(selectedIds, impression.id)}
                        type="checkbox"
                        checked={isPresentInArray(selectedIds, impression.id)}
                        className="custom-control-input" id={`impression-select-${impression.id}`} />
                      <label className="custom-control-label" htmlFor={`impression-select-${impression.id}`}></label>
                    </div>
                  </td>}
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}


export default Impression;
